import initData from 'init-data';

export default {
    MEMBER_SYSTEM_MESSAGES: initData.memberSystemMessagesUrl,
    GET_CATEGORY_LIST: initData.getCategoryListUrl,
    GET_ITEM: initData.getItemUrl,
    LOGIN_STATE: initData.loginStateUrl,
    MESSAGING_PARTICIPATION: initData.messagingParticipationUrl,
    MESSAGING_NOTIFICATIONS: initData.messagingNotificationsUrl,
    MESSAGING_EMAIL_SETTINGS: initData.messagingEmailSettingsUrl,
    MESSAGING_SET_PARTICIPATION: initData.messagingSetParticipationUrl,
    PAYMENT_SWISH_OPTOUT: initData.paymentSwishOptoutUrl,
    SEARCH: initData.searchBaseUrl,
    SAVED_SEARCH_ADD: initData.savedSearchAddUrl,
    SAVED_SEARCH_REMOVE: initData.savedSearchRemoveUrl,
    SAVED_SEARCH_NOTIFICATION: initData.savedSearchNotificationUrl,
    WISHLIST_ADD: initData.wishlistAddUrl,
    WISHLIST_REMOVE: initData.wishlistRemoveUrl,
    SELLING_ATTRIBUTES: initData.sellingAttributesUrl,
    CHARITY_EARNINGS_TICKER: initData.charityEarningsTickerUrl,
    SETTINGS: initData.settingsUrl,
    FAVORITE_SELLER_ADD: initData.favoriteSellerAddUrl,
    FAVORITE_SELLER_REMOVE: initData.favoriteSellerRemoveUrl,
    LAST_CHANCE: initData.lastChanceUrl,
    ITEM_DESCRIPTION: itemId =>
        initData.itemDescriptionUrl.replace('$itemId', itemId)
};
